import { Observable, timer } from 'rxjs';
import { take, map, takeWhile } from 'rxjs/operators';

export class Countdown {
    static start(minutes: number, delay: number = 0) {
        return new Observable<{ display: string; minutes: number; seconds: number }>((subscriber) => {
            timer(delay, 1000)
                .pipe(take(minutes * 60))
                .pipe(map((v) => minutes * 60 - 1 - v))
                .pipe(takeWhile((x) => x >= 0))
                .subscribe((countdown) => {
                    // countdown => seconds
                    const minutes = Math.floor(countdown / 60);
                    const seconds = countdown - minutes * 60;

                    subscriber.next({
                        display: `${('0' + minutes.toString()).slice(-2)}:${('0' + seconds.toString()).slice(-2)}`,
                        minutes,
                        seconds,
                    });

                    if (seconds <= 0 && minutes <= 0) {
                        subscriber.complete();
                    }
                });
        });
    }
}
